<template>
  <component
    :is="component"
    v-if="component"
    :record.sync="dataTransform"
    :type="type" />
</template>
<script>
  export default {
    props: {
      record: Object,
      type: String
    },
    data () {
      return {
        component: null
      }
    },
    computed: {
      loader () {
        let type = this.type
        if (!type) {
          return null
        }
        return () => import(`@/components/ui/ChatMessages/${type}`)
      },
      dataTransform () {
        const data = Object.assign({}, this.record.data, { input: false })
        return Object.assign({}, this.record, { data })
      }
    },
    mounted () {
      this.loader()
        .then(() => {
          this.component = () => this.loader()
        })
        .catch(() => {
          console.log('ComponentNotFound:', this.type)
          this.component = () => import(`@/components/ui/ChatMessages/Message`)
        })
    }
  }
</script>
